import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const reportIdSelector = (state) => resolveProp('dashboard.data.creditReportInfo.clientRef', state);
const scoreProviderSelector = (state) => resolveProp('dashboard.data.creditReportInfo.scoreProvider', state);
const daysUntilNextReportSelector = (state) =>
    resolveProp('dashboard.data.creditReportInfo.daysUntilNextReport', state);
const changedScoreSelector = (state) => resolveProp('dashboard.data.creditReportInfo.changedScore', state);
const numPositiveFactorsSelector = (state) =>
    resolveProp('dashboard.data.creditReportInfo.numPositiveScoreFactors', state);
const numNegativeFactorsSelector = (state) =>
    resolveProp('dashboard.data.creditReportInfo.numNegativeScoreFactors', state);

const daysToNextIdentificationCheckSelector = (state) =>
    resolveProp('dashboard.data.daysToNextIdentificationCheck', state);

export default createSelector(
    reportIdSelector,
    scoreProviderSelector,
    daysUntilNextReportSelector,
    changedScoreSelector,
    numPositiveFactorsSelector,
    numNegativeFactorsSelector,
    daysToNextIdentificationCheckSelector,
    (
        reportId,
        scoreProvider,
        daysUntilNextReport,
        changedScore,
        numPositiveFactors,
        numNegativeFactors,
        daysToNextIdentificationCheck,
    ) => ({
        reportId,
        scoreProvider,
        daysUntilNextReport,
        changedScore,
        numPositiveFactors,
        numNegativeFactors,
        numFactors: numPositiveFactors + numNegativeFactors,
        daysToNextIdentificationCheck,
    }),
);
